const TAILWIND_COLOR_SHADES = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900] as const;

/**
 * Border utility one step darker than a Tailwind `bg-{color}-{shade}` class (~20% on the scale).
 */
export function borderClassFromBgClass(bgClass: string): string | null {
  const match = bgClass.match(/^bg-([a-z]+(?:-[a-z]+)?)-(\d+)$/);
  if (!match) return null;

  const [, color, shadeStr] = match;
  const shade = Number(shadeStr);
  const shadeIndex = TAILWIND_COLOR_SHADES.indexOf(
    shade as (typeof TAILWIND_COLOR_SHADES)[number]
  );
  const darkerShade =
    shadeIndex >= 0 && shadeIndex < TAILWIND_COLOR_SHADES.length - 1
      ? TAILWIND_COLOR_SHADES[shadeIndex + 1]
      : Math.min(shade + 100, 900);

  return `border-${color}-${darkerShade}`;
}
